import { render, staticRenderFns } from "./NlPrivacyPolicy.vue?vue&type=template&id=3831efb9&scoped=true"
import script from "./NlPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./NlPrivacyPolicy.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "3831efb9",
  null
  ,true
)

export default component.exports